const listeners = new Map();

export default {
    on(event, callback) {
        if (!listeners.has(event)) {
            listeners.set(event, []);
        }

        const eventListeners = listeners.get(event);

        // Prevent duplicate registration
        if (!eventListeners.includes(callback)) {
            eventListeners.push(callback);
        } else {
            console.warn(`[EventBus] Listener already registered for "${event}"`);
        }
    },

    off(event, callback) {
        if (!listeners.has(event)) {
            return;
        }

        if (!callback) {
            listeners.delete(event); // remove all listeners for this event
        } else {
            const filtered = listeners.get(event).filter(fn => fn !== callback);
            if (filtered.length > 0) {
                listeners.set(event, filtered);
            } else {
                listeners.delete(event);
            }
        }
    },

    emit(event, payload) {
        if (!listeners.has(event)) {
            return;
        }

        // console.log(`[EventBus] Emitting "${event}" to ${listeners.get(event).length} listener(s)`);

        for (const fn of listeners.get(event)) {
            fn(payload);
        }
    },
}
